import { FILTER, FILTERS_LOCATION } from '@fiverr-private/listing_lib';
import { filterNavigation } from '../../../service/clientNavigation';

export const filterAndSort = (filters = [], groupingKey) =>
    filters.filter(({ topGrouping }) => topGrouping === groupingKey).sort((a, b) => a.order - b.order);

export const getFilterDisplay = (filter, activeFilters) => ({
    title: filter.alias,
    active: isActive([filter], activeFilters),
});

export const isActive = (filters, activeFilters) =>
    filters.reduce((active, filter) => active || !!activeFilters[filter.id], false);

export const applyTopBarFilters = (
    change,
    active,
    filtersGroupName,
    location = FILTERS_LOCATION.FLOATING_TOP,
    source = 'drop_down_filters'
) => filterNavigation(change, active, location, source, filtersGroupName);

export const isOnlineNowSelected = (activeFilters) =>
    Boolean(activeFilters?.[FILTER.IS_SELLER_ONLINE.ID]) ||
    Boolean(activeFilters?.[FILTER.IS_SELLER_ONLINE.BUSINESS_ID]);
